export const EVENT_NAME = 'message';
export const TOKEN_TYPE = 'token';
export const REQUEST_TOKEN_TYPE = 'requestTokenFromRocky';
export const BONUSES_READY = 'kpiToolBonusesReady';
